import posthog from 'posthog-js'

export default defineNuxtPlugin(() => {
    const posthogClient = posthog.init('phc_pkhg0divQdDhlidvBYMFcMlFW5c8uzex2YTUbkdoGRX', {
        api_host: 'https://app.posthog.com',
        session_recording: { maskAllInputs: false, maskInputOptions: { password: true } },
    })

    // Make sure that pageviews are captured with each route change
    const router = useRouter();
    router.afterEach((to) => {
        posthog.capture('$pageview', {
            current_url: to.fullPath
        });
    });

    return {
        provide: {
            posthog: () => posthogClient ? posthogClient : null,
        }
    }
})
